module.exports = __webpack_public_path__ + "img/pauline-vos-the-kiss.464ff79.jpg";